"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgPriceTag = function SvgPriceTag(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M1024 416c0 15.333-.833 30.333-2.5 45-1.667 14.667-7.833 27.333-18.5 38l-506 506c-6.667 6-13.833 10.667-21.5 14s-15.833 5-24.5 5-16.833-1.667-24.5-5c-7.667-3.333-14.5-8-20.5-14L19 618c-6-6-10.667-12.833-14-20.5S0 581.667 0 573s1.667-16.833 5-24.5c3.333-7.667 8-14.833 14-21.5L525 21c10.667-10.667 23.167-16.833 37.5-18.5C576.833.833 589.667 0 601 0h345c21.333 0 39.667 7.667 55 23 15.333 15.333 23 33.667 23 55v338zm-67 38c1.333-2.667 2.167-8 2.5-16 .333-8 .5-15 .5-21V78c0-4-1.333-7.333-4-10s-6-4-10-4H601c-4 0-9.667.167-17 .5-7.333.333-12 1.167-14 2.5L64 573l387 387 506-506zM768 128c35.334 0 65.5 12.5 90.5 37.5S896 220.666 896 256s-12.5 65.5-37.5 90.5S803.334 384 768 384s-65.5-12.5-90.5-37.5S640 291.334 640 256s12.5-65.5 37.5-90.5S732.666 128 768 128zm0 192c18 0 33.167-6.167 45.5-18.5C825.833 289.167 832 274 832 256s-6.167-33.167-18.5-45.5C801.167 198.167 786 192 768 192c-17.333 0-32.333 6.167-45 18.5-12.667 12.333-19 27.5-19 45.5s6.333 33.167 19 45.5c12.667 12.333 27.667 18.5 45 18.5z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgPriceTag, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;